<template>
    <div class="date-picker">
        <span v-show="isClearVisible" class="fa fa-times" @click="clear"></span>
        <date-picker
                ref="datePicker"
                :name="name"
                :value="date"
                input-class="form-control"
                :config="config"
                :disabled="disabled"
                :placeholder="placeholder"
                @input="onInput"
        />
    </div>
</template>

<script>
// Import required dependencies
import 'bootstrap/dist/css/bootstrap.css'
import 'moment/locale/pl'
// Import this component
import datePicker from 'vue-bootstrap-datetimepicker'
const jQuery = window.jQuery || require('jquery')

// Import date picker css
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import DateHelper from '@js/helpers/dateHelper'

export default {
  components: {
    datePicker
  },
  props: {
    name: {
      type: String,
      default: 'datetime'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Date],
      default: null
    },
    time : {
      type: Boolean,
      default : true
    },
    isNullable: {
      type: Boolean,
      default: true,
    },
    initValue: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    canClear: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      config: {
        format: this.time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD',
        locale: 'pl',
      },
      focus: false,
    }
  },
  computed: {
    isClearVisible() {
      return this.date && this.canClear && !this.focus && !this.disabled
    },
    datePicker() {
      const datePicker = this.$refs.datePicker
      return jQuery(datePicker.wrap ? datePicker.$el.parentNode : datePicker.$el)
    },
    date: {
      get: function() {
        return this.value
      },
      set: function(value) {
        if (this.value !== value) {
          if (value && typeof value === 'object') {
            this.$emit('input', DateHelper.format(value))
          } else if (!value && !this.isNullable) {
            this.date = this.value ? this.value : new Date()
          } else {
            this.$emit('input', value)
          }
        }
      }
    }
  },
  mounted: function () {
    if (this.value) {
      this.date = this.value
    }

    this.datePicker.on('dp.hide', () => {
      this.focus = false
      this.$emit('hide')
    })

    this.datePicker.on('dp.show', () => {
      this.focus = true
      this.$emit('show')
    })
  },
  methods: {
    onInput(value) {
      this.date = value || null
    },
    clear() {
      this.date = null
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>

.date-picker {
    position: relative;
}

.date-picker .fa-times {
    position: absolute;
    right: 15px;
    color: #999;
    top: 10px;
    cursor: pointer;
    font-size: 12px;
}
</style>
